export default __webpack_public_path__ + "static/media/nutrition-cap60.3ecb026c.jpeg";